export default __webpack_public_path__ + "static/media/Ellipse14.c9df31fb.png";